import request from '../../request'; // local module at root of app.

/**
 * List all users of the dealership
 */
export const listUsers = () =>
  request('common/users/', {
    method: 'GET',
  });

export const updateUser = (userProfileId: number, role: number, actingAs: string | number) => {
  // if deleting a user at a lower level in hierarchy, append acting_as param
  const params = new URLSearchParams();
  if (actingAs !== null && actingAs !== undefined && actingAs !== '') {
    params.append('acting_as', String(actingAs));
  }

  return request(`common/profiles/${userProfileId}/`, {
    method: 'PATCH',
    data: {
      role,
    },
    params,
  });
};

export const deleteUser = (userId: number, actingAs: string | number) => {
  // if deleting a user at a lower level in hierarchy, append acting_as param
  const params = new URLSearchParams();
  if (actingAs !== null && actingAs !== undefined && actingAs !== '') {
    params.append('acting_as', String(actingAs));
  }

  return request(`common/users/${userId}/`, {
    method: 'DELETE',
    params,
  });
};

export const createUser = (email: string, role: string, actingAs: string | number) => {
  // if creating a user at a lower level in hierarchy, append acting_as param
  const params = new URLSearchParams();
  if (actingAs !== null && actingAs !== undefined && actingAs !== '') {
    params.append('acting_as', String(actingAs));
  }

  return request(`common/users/`, {
    method: 'POST',
    data: {
      email,
      profile: {
        role,
      },
    },
    params,
  });
};

export const sendActivation = (userId) =>
  request(`common/users/${userId}/resend_activation/`, {
    method: 'POST',
  });
